var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"grid-cell-link",on:{"click":function($event){return _vm.onClick()}}},[_c('span',[_vm._v(_vm._s(_vm.clearText))])])}
var staticRenderFns = []

export { render, staticRenderFns }